import styled from 'styled-components'
import { theme } from '../../../../style/theme'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const MobileCartButtonWrap = styled.div`
	display: none;

	@media screen and (max-width: ${theme.point820}) {
		display: block;
	}
`
MobileCartButtonWrap.displayName = 'MobileCartButtonWrap'

export const CartButton = styled.button`
	font-size: 1rem;
	padding: 0.63rem;
	height: 3.43em;
	width: 100%;
	position: relative;
	border-radius: 0.75em;
	display: flex;
	justify-content: center;
	gap: 0.32em;
	align-items: center;
	cursor: pointer;
	transition: all 0.3s ease;
	background-color: ${colorTheme.cart.mobileCartButtonBig.background};

	svg {
		width: 1.81em;
		height: 1.81em;
		fill: ${colorTheme.cart.mobileCartButtonBig.icon};
	}

	&:hover {
		background-color: ${colorTheme.cart.mobileCartButtonBig.btnHover};
		box-shadow: none;

		svg {
			fill: ${colorTheme.cart.mobileCartButtonBig.iconHover};
		}
	}
`
CartButton.displayName = 'CartButton'

export const CartButtonCount = styled.div`
	display: flex;
	height: 1.5em;
	min-width: 1.5em;
	padding: 0 0.25em;
	justify-content: center;
	align-items: center;
	gap: 0.32em;
	border-radius: 50%;
	background: ${colorTheme.cart.mobileCartButtonBig.countBackground};
	transform: translateY(-0.32em);
`
CartButtonCount.displayName = 'CartButtonCount'

export const CartButtonCountText = styled.div`
	font-size: 0.87em;
	color: ${colorTheme.cart.mobileCartButtonBig.countText};
	font-family: ${theme.fontRobotoMedium};
`
CartButtonCountText.displayName = 'CartButtonCountText'
